import * as yup from 'yup';
import { emailRegex } from '@/consts/const';
import { nullableString } from '@/utils/validations';
import { SHARE_CARD_FORM_VALUES, type SHARE_CARD_DETAILS_FORM_TYPE } from './consts';

export const MAX_MESSAGE_LENGTH = 1000;
export const MAX_SIGNATURE_LENGTH = 300;
export const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address.';

export const emailSchema = yup.object().shape({
  email: yup
    .string()
    .email(INVALID_EMAIL_MESSAGE)
    .matches(emailRegex, INVALID_EMAIL_MESSAGE)
    .required('Client email is required'),
  cc_email: yup.string().test('is-email', INVALID_EMAIL_MESSAGE, function (value) {
    if (!value || value === '') return true;
    return emailRegex.test(value);
  }),
  bcc_email: yup.string().test('is-email', INVALID_EMAIL_MESSAGE, function (value) {
    if (!value || value === '') return true;
    return emailRegex.test(value);
  }),
  selectedForms: yup
    .array(yup.mixed<SHARE_CARD_DETAILS_FORM_TYPE>().oneOf(SHARE_CARD_FORM_VALUES).required())
    .min(1, 'Please select at least one form')
    .required(),
  message: yup.string().optional().max(MAX_MESSAGE_LENGTH, `Message cannot exceed ${MAX_MESSAGE_LENGTH} characters`),
  signature: nullableString()
    .max(MAX_SIGNATURE_LENGTH, `Signature cannot exceed ${MAX_SIGNATURE_LENGTH} characters`)
    .defined(),
});
